import SettingsItem from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItem";
import SettingsItemText from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsItemText";
import SettingsSection from "@/components/PageEditor/components/Viewport/components/Sidebar/components/Settings/components/SettingsSection";
import { useDataStore, useFilterStore } from "@/stores";
import { useEditor, useNode } from "@craftjs/core";
import { Grid, MenuItem } from "@mui/material";

const Settings = () => {
    const { id } = useNode();
    const { displayName, filterField, filterValue, actions } = useEditor((state) => ({
        displayName:
            state.nodes[id] && state.nodes[id].data.custom.displayName
                ? state.nodes[id].data.custom.displayName
                : state.nodes[id].data.displayName,
        filterField: state.nodes[id].data.props.filterField,
        filterValue: state.nodes[id].data.props.filterValue,
    }));

    const software = useDataStore((x) => x.software);
    const activeVersion = useFilterStore((state) => state.activeVersion);

    return (
        <>
            <SettingsSection
                title="Identification"
                summary={() => {
                    return `${displayName || "-"}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItemText
                        type={"text"}
                        value={displayName}
                        onChange={(value: string) => {
                            actions.setCustom(id, (custom) => (custom.displayName = value));
                        }}
                        fullWidth={true}
                        label="Display name"
                    />
                </Grid>
            </SettingsSection>
            <SettingsSection
                title="Filter"
                summary={() => {
                    return `${filterField || "-"}${filterValue ? `: ${filterValue}` : ""}`;
                }}
            >
                <Grid size={{ xs: 12 }}>
                    <SettingsItem fullWidth propKey="filterField" type="select" label="Field">
                        <MenuItem value={""}>None</MenuItem>
                        <MenuItem value={"software"}>Active software</MenuItem>
                    </SettingsItem>
                    <br />
                    <SettingsItem fullWidth propKey="filterValue" type="select" label="Field">
                        <MenuItem value={""}>None</MenuItem>
                        <MenuItem value={"no-ifc"}>No IFC version selected</MenuItem>
                        <MenuItem value={"no-software"}>No software selected</MenuItem>
                        <MenuItem value={"no-selection"}>Nothing selected</MenuItem>

                        {software[activeVersion!]
                            .filter((x) => x.active)
                            .map((software, index) => {
                                const key = software.name;
                                const label = software.name;

                                return (
                                    <MenuItem value={key} key={index}>
                                        {label}
                                    </MenuItem>
                                );
                            })}
                    </SettingsItem>
                </Grid>
            </SettingsSection>
        </>
    );
};

export default Settings;
